import { createContext } from "react";

export const STORAGE_KEY_STORED_PIN = "pin/storedPin";

export const Context = createContext(null);
